import $http from "@/helpers/http";
import Logger from "@/helpers/logger";

class DomainApi {
  getDnsConfig(payload) {
    try {
      const url = `/panel/dns-config`;
      return $http.post(url, payload);
    } catch (e) {
      Logger.error("`getDnsConfig` api", e);
      return Promise.reject(e);
    }
  }

  getDnsRecords() {
    try {
      const url = "/panel/domain/getDnsRecords";
      return $http.get(url);
    } catch (e) {
      Logger.error("`getDnsRecords` api", e);
      return Promise.reject(e);
    }
  }

  verifyDkim(params) {
    try {
      return $http.post("/panel/domain/dkim/enable", params);
    } catch (e) {
      Logger.error("`verifyDkim` api", e);
      return Promise.reject(e);
    }
  }

  generateDkim() {
    try {
      return $http.post("/panel/domain/dkim/generate");
    } catch (e) {
      Logger.error("`generateDkim` api", e);
      return Promise.reject(e);
    }
  }

  deleteDnsRecord(payload) {
    try {
      return $http.post("/panel/domain/deleteDnsRecord", payload);
    } catch (e) {
      Logger.error("`deleteDnsRecord` api", e);
      return Promise.reject(e);
    }
  }

  upsertDnsRecord(payload) {
    try {
      return $http.post("/panel/domain/upsertDnsRecord", payload);
    } catch (e) {
      Logger.error("`upsertDnsRecord` api", e);
      return Promise.reject(e);
    }
  }

  dkimEnable(payload) {
    try {
      return $http.post("/panel/domain/dkim/enable", payload);
    } catch (e) {
      Logger.error("`dkimEnable` api", e);
      return Promise.reject(e);
    }
  }

  dkimDelete(payload) {
    try {
      return $http.post("/panel/domain/dkim/delete", payload);
    } catch (e) {
      Logger.error("`dkimDelete` api", e);
      return Promise.reject(e);
    }
  }

  getDnsRecordType(payload) {
    try {
      return $http.post("/internal/dns/fetchDnsRecordType", payload);
    } catch (e) {
      Logger.error("`getDnsRecordType` api", e);
      return Promise.reject(e);
    }
  }
}

const domainApi = new DomainApi();

export default domainApi;
